<template>
    <div>
        <v-divider class="border-2 grey darken-4" />
        <!-- 반복 -->
        <template v-for="notification in notifications">
            <v-row :key="notification._id" no-gutters>
                <v-col cols="12">
                    <router-link :to="`/center/notice/${notification._id}`">
                        <v-row no-gutters align="center" justify="space-between" class="flex-md-nowrap">
                            <v-col cols="12" md="9" class="flex-grow-1 flex-shrink-0">
                                <div class="px-12px pt-12px pb-6px px-md-16px py-md-30px">
                                    <div class="txt txt--lg txt--dark text-truncate">{{ notification?.subject }}</div>
                                </div>
                            </v-col>
                            <v-col cols="12" md="auto">
                                <div class="px-12px pb-10px py-md-30px">
                                    <div class="txt txt--lg txt--light">{{ $dayjs(notification?.createdAt).format("YYYY-MM-DD") }}</div>
                                </div>
                            </v-col>
                        </v-row>
                    </router-link>
                </v-col>
            </v-row>
            <v-divider class="border-light" :key="notification._id"/>
        </template>
        <!-- // 반복 -->
    </div>
</template>

<script>
import api from "@/api";

export default {
    props: {},
    components: {},
    data: () => {
        return {
            filter: {
                isNotice: false,
            },
            notifications: [],
            limit: 5,
        };
    },
    async mounted() {
        await this.init();
    },
    methods: {
        async init() {
            let { notifications } = await api.v1.center.notifications.gets({
                headers: {
                    limit: this.limit,
                },
            });

            this.notifications = notifications;
        },
    },
};
</script>

<style lang="scss" scoped></style>
